import { gql } from '@apollo/client'

const UPDATE_DISH_TYPE_IMAGE_DETAILS_MUTATION = gql`
  mutation updateDishTypeImageDetails(
    $id: ID!
    $data: DishTypeImageDetailsInput!
  ) {
    updateDishTypeImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
      processedImageUrl
      iconUrl
    }
  }
`

export default UPDATE_DISH_TYPE_IMAGE_DETAILS_MUTATION
